import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiLiftChairSide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.04 5.78a1 1 0 0 0 1.24.68l3.148-.926L11.46 8c-2.12.04-3.96 1.89-3.96 4v4.5c0 1.57 1.47 3 3.08 3H12l-.01.01a1 1 0 0 0 .141-.01H13V21c0 .55.45 1 1 1h1.5c.55 0 1-.45 1-1s-.45-1-1-1H15v-4.5c0-.55-.45-1-1-1h-2.5V14c0-.55-.45-1-1-1s-1 .45-1 1v.5h-.01v-2.49c0-1.01 1.01-2 2.03-2h.95a1 1 0 0 0 .71-.3 1 1 0 0 0 .29-.71l-.05-4.052 3.36-.988c.53-.15.84-.71.68-1.24a.994.994 0 0 0-1.24-.68l-8.5 2.5c-.53.15-.84.71-.68 1.24M9.49 16.5v.01a1 1 0 0 0 .01.113V16.5zm2.01 0v1H13v-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSkiLiftChairSide;
